<template>
  <q-banner class="errorBox text-negative theme-bg-gray q-pa-md">
    <div class="error border-radius-8 q-pa-sm text-left">
      <q-icon
        name="error"
        size="24px"
        color="negative"
      />
      <span class="font-size-16 q-ml-xs"> Error detail</span>
    </div>
  </q-banner>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.error {
  line-height: 120%;
  background: #fee2e2;
  span {
    vertical-align: middle;
  }
}
</style>
